
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObcRotIndicator as ObcRotIndicatorElement} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/rot-indicator/rot-indicator.js';
 
 
 

 
 export const ObcRotIndicator = createComponent({
   react: React,
   tagName: 'obc-rot-indicator',
   elementClass: ObcRotIndicatorElement,
   events: {
     
   }
  });
 
 